import FullScreenLoader from '@/components/feedback/FullScreenLoader';
import GuestGuard from '@/features/auth/components/GuestGuard';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

/**
 * Guest layout — wraps auth pages (login, register).
 * Redirects to home if the user is already logged in.
 */
export default function GuestLayout() {
  return (
    <GuestGuard>
      <Suspense fallback={<FullScreenLoader />}>
        <Outlet />
      </Suspense>
    </GuestGuard>
  );
}
